<template>
  <!-- 移动端 -->
	<div>
		<div class="login-mobile-container" v-if="isMobile">
			<div class="login-mobile-content">
				<div class="item-img">
					<img :src="logoPng" width="188" height="60"/>
				</div>
				<div class="item-info">
					<xt-input label="账号"
										style="margin-bottom: -15px"
										placeholder="请输入证件号码或手机号码"
										v-model="userName"
										ref="account"
										@blur.prevent="geTryCount()">
					</xt-input>
					<xt-input label="密码"
										style="margin-bottom: -15px"
										placeholder="请输入密码"
										v-model="userPassword"
										:input-type="contentType"
										@blur.prevent="resetWindow"
										ref="password">
						<div slot="subfix">
							<img :src="iconEye" width="24" v-if="!showPassWord" @click="showPassWord = true"/>
							<img :src="iconEyeClose" width="24" v-else @click="showPassWord = false"/>
						</div>
					</xt-input>
          
				</div>

				<div class="item-choose">
					<div v-track-click="{eventId: 'wechatBindLogin', title: '绑定微信快捷登录'}">
						<xt-checkbox v-model="wechatBind"><span>绑定微信快捷登录</span></xt-checkbox>
					</div>
					<div @click="toFindPassWordPage()" v-track-click="{eventId: 'findPassWordMobile', title: '找回密码'}"><span>找回密码</span></div>
				</div>
				<div><span
					style="padding-left: 20px;display: inline-block;vertical-align: text-top;text-align: left;line-height: 18px;color: #BBBBBB;font-size: 12px;font-weight: 400">如果选择使用绑定微信快捷登录，您的账号将与微信账号绑定，再次登录时将无需输入账号、密码。</span>
				</div>
				<xt-button class="item-btn"
									 @click="userLogin"
									 :disabled="loginBtnDisabled" v-track-click="{eventId: 'userLoginMobile', title: '登录' }">登录
				</xt-button>
				<div class="item-regist">没有账号？立即<span @click="showRegisterTip">注册</span>></div>
			</div>
			<div class="item-contect">
				如有疑问，请咨询工作人员<br/>0755-88693999<br/>{{WorkdayTimeText}}
			</div>
      <!-- 短信验证 -->
			<xt-message :visible="messageBoxShow"
									type="login"
									:on-verify="verifyLoginMsgCode"
									@success="loginVerifyMsgSuccess"
									:on-send="sendLoginMsg"
									:on-send-voice="sendLoginVoiceMsg"
									@close="handlerCloseMessagePop"
									:mobile-prop="this.userMobile"
                  :user-name="this.userName"
			></xt-message>
			<xt-dialog :visible="showPop"
								 :type="isConfirm ? 'confirm': ''"
								 :confirmText="isConfirm? '继续注册':'确定'"
								 cancel-text="取消"
								 @confirm="toRegister"
								 @cancel="showPop = false,isConfirm = false">
				<div class="item-dialog">{{popContent}}</div>
			</xt-dialog>
		</div>

    <!-- pc端 -->
		<div v-else>
			<div class="login-container web" >
				<div class="web-txt-png">
					<img :src="titlePng" alt="" style="width: 493px;margin-top: 230px">
					<!-- <img :src="txtPng" alt="" style="display: block;width: 383px;margin-top: 20px"> -->
				</div>
				<el-form style="position:absolute;top:70px;margin-right: 30%">
					<el-form-item class="login-input">
						<el-input type="text" id="account" ref="account" placeholder="请输入证件号码或手机号码" v-model="userName"
											@blur.prevent="geTryCount()"/>
						<div v-show="verity.userName" class="color-red">{{verity.curTips}}</div>
					</el-form-item>
					<el-form-item class="login-input">
						<el-input :type="contentType"
											placeholder="请输入密码"
											v-model="userPassword"
											@keyup.13.native="userLogin"
											ref="password">
							<template slot="suffix">
								<img :src="iconEye" @click="showPassWord = true" style="margin-top: 7px" v-if="!showPassWord" width="24"/>
								<img :src="iconEyeClose" @click="showPassWord = false" style="margin-top: 7px" v-else width="24"/>
							</template>
						</el-input>
						<div v-show="verity.userPassword" class="color-red">{{verity.curTips}}</div>
					</el-form-item>
          <!-- 之前的验证码 -->
					<!-- <el-row v-show="codeStatus" style="height: 40px;top: 3px;">
						<el-col :span="15" style="height: 40px">
							<div class="grid-content bg-purple">
								<el-form-item class="login-input" style="width: 176px;">
									<el-input type="text" v-model.trim='verifyCode' placeholder="验证码" width="150px"/>
								</el-form-item>
							</div>
						</el-col>
						<el-col :span="9">
							<div class="grid-content">
								<div class="extra img verify-img-container" @click="getVerifyCodeUrl">
									<img :src="verifyCodeUrl" alt="" width="112">
								</div>
							</div>
						</el-col>
					</el-row> -->
					<!-- <div v-show="verity.code"
							 class="color-red"
							 style="margin-top: 11px;margin-bottom: -28px;">
						{{verity.verifyCodeTips}}
					</div> -->
					<div style="margin-top: 32px;margin-bottom: 19px;width: 315px">
						<el-form-item size="mini">
							<xt-checkbox  style="float:left;color:#c99663;" v-model="rememberUsername">记住账号</xt-checkbox>

							<div
								@click="toFindPassWordPage()"
								class="pointer find-password-web"
								style="font-size: 14px;float: right;"
							>找回密码
							</div>
						</el-form-item>
					</div>
					<el-form-item style="margin-bottom: 10px;">
						<button :disabled="webloginDisableBtn" @click="userLogin" class="login-btn-web" type="button" v-track-click="{eventId: 'userLogin', title: '登录'}">登 录</button>
					</el-form-item>
					<el-form-item style="margin-bottom: 49px;width: 310px;text-align: center">
						<div class="register-text">还没有账号?<span class="register-link" @click="confirmRegist">马上注册</span></div>
						<div style="line-height: 20px;margin-top: 25px;font-size: 12px;color: #BBBBBB">
							如有疑问，请咨询工作人员<br/>0755-88693999<br/>{{WorkdayTimeText}}
						</div>
					</el-form-item>
				</el-form>
			</div>
			<xt-login-message-web :visible="messageBoxShow"
														type="login"
														:on-verify="verifyLoginMsgCode"
														@success="loginVerifyMsgSuccess"
														:on-send="sendLoginMsg"
														:on-send-voice="sendLoginVoiceMsg"
														@close="messageBoxShow = false"
														:mobile-prop="this.userMobile"
                            :user-name="this.userName">
			</xt-login-message-web>

		</div>

		<xt-dialog-web :visible="showRegisterConfirm"
									 @cancel="showRegisterConfirm = false"
									 @confirm="register"
									 confirm-text="继续注册"
									 type="confirm">
			<div style="font-size: 12px;color: rgba(26, 26, 26, 0.6);">
				本系统仅供持有我司主动管理产品的客户查看，暂不对持有我司担任投顾的产品及未持有我司产品的人士开放。
			</div>
		</xt-dialog-web>
		<!--新增通知内容-->
		<div class="register-agree" v-if="isNotice">
			<notice :content="myNoticeContent" :title="myNoticeTitle" @closeNotice="closeNotice"
			></notice>
		</div>
	</div>
</template>

<script>
import {userStatus, userInfo, agreementInfo, agreement} from '../service/user'
import registerAgreement from '../components/register-agreement'
import titlePng from '../assets/title.png'
import txtPng from '../assets/txt.png'
import logoPng from '../assets/logo_blue.png'
import {myNoticeInfo} from '../service/notice.js'
import {
  getCaptchaUrl,
  checkCaptcha,
  sendLoginMessage,
  sendLoginVoiceMessage,
  verifyLoginMsgCode
} from '../service/support.js'
import {getFailCount, verifyIpAddress, queryUserMobile, checkInitialPasswordLogin} from '../service/login.js'
import XtButton from "../components/xtButton";
import XtInput from "../components/xtInput";
import iconEye from '../assets/eye-open.svg'
import iconEyeClose from '../assets/eye-close.svg'
import XtRadio from "../components/xtRadio";
import XtSaveSuccess from "../components/xt-success";
import XtDialog from "../components/xtDialog";
import XtCheckbox from "@/components/xtCheckbox";
import {isNull, tencentVerification} from "../util/common";
import XtDialogWeb from "../components/xtDialogWeb";
import XtMessage from "../components/xtMessage";
import XtMessageWeb from "../components/xtMessageWeb";
import XtLoginMessageWeb from "../components/xtLoginMessageWebNew";
import {webTracingClearUserUuid} from "@/service/common";
import {WorkdayTimeText} from '@/common/constant'

import {mapMutations} from "vuex"

const BlockedVisitMSG = '连续访问失败次数过多，请联系工作人员。'
const MultiUser = '此手机号已关联多个帐号，请改用证件号登录'
const multiUserValue = '0';

// 判断是否微信浏览器
function isWeixinBrowser() {
  return !!(/micromessenger/.test(window.navigator.userAgent.toLowerCase()))
}

export default {
  name: 'login-page',
  components: {
    XtLoginMessageWeb,
    XtMessageWeb,
    XtMessage,
    XtDialogWeb,
    XtCheckbox,
    XtDialog,
    XtSaveSuccess,
    XtRadio,
    XtInput,
    XtButton,
    registerAgreement,
  },
  data() {
    return {
      WorkdayTimeText: WorkdayTimeText,
      userName: '',
      userPassword: '',
      contentType: 'password',
      verifyCode: '',//验证码
      verifyCodeUrl: '',
      // codeStatus: false,
      blockedVisit: false,
      iconEye: iconEye,
      iconEyeClose: iconEyeClose,
      showPassWord: true,
      failCount: 0,
      tryCount: 0, //试错次数
      loginBtnDisabled: false,
      showPop: false,
      isConfirm: false,
      popContent: '',
      error: '', // 错误信息, 需要给客户看错误内容
      verity: {
        userPassword: false,
        userName: false,
        code: false,
        curTips: '账号或密码错误',
        verifyCodeTips: '',
        tips: ['账号不能为空', '密码不能为空', '账号或密码错误', '验证码错误', '验码不能为空', '系统流量限制，请稍后再试'] //dailog提示
      }, // 验证
      agreeShow: false,
      wechatBind: true,
      myNoticeTitle: '',
      myNoticeContent: {},
      isNotice: false,
      rememberUsername: !isNull(localStorage.getItem('userName')),
      showRegisterConfirm: false,
      block_visit: false,
      messageBoxShow: false,
      userMobile: '',
      ticket: '',
      randStr: '',
    }
  },
  computed: {
    isMobile() {
      return this.$root.isMobile
    },
    isWechat() {
      return isWeixinBrowser()
    },
    titlePng() {
      return titlePng
    },
    txtPng() {
      return txtPng
    },
    rImgVal() {
      return this.verifyCode.toLowerCase()
    },
    logoPng() {
      return logoPng
    },
    webloginDisableBtn() {
      return this.userName === '' || this.userName === undefined
    }
  },
  methods: {
    ...mapMutations(['clearUser']),
    async showRegisterTip() {
      let blockedFlag = await this.checkBlock()
      if (!blockedFlag) {
        return
      }
      this.popContent = '本系统仅供持有我司主动管理产品的客户查看，暂不对持有我司担任投顾的产品及未持有我司产品的人士开放。'
      this.showPop = true
      this.isConfirm = true
    },
    register() { // web端继续注册
      this.showRegisterConfirm = false
      if (this.isMobile) {
        this.$router.push('/registMobileOne')
      } else {
        this.$router.push('/register')
      }
    },
    async confirmRegist() {
      let blockedFlag = await this.checkBlock()
      if (!blockedFlag) {
        return
      }
      this.showRegisterConfirm = true
    },
    toRegister() { // 移动端继续注册
      this.showPop = false
      if (this.isConfirm) {
        this.isConfirm = false
        this.$router.push('/register')
      }
    },
    closeNotice() {
      this.isNotice = false
      this.onAfterNoticed()
    },
    onAfterNoticed() {

    },
    getAgreementOnLogin(userInfos) {
      let agree = userInfos.agree
      this.getAgreements(agree)
    },
    async getNoticeOnLogin() {
      let data = await myNoticeInfo()
      if (data.result) {
        this.myNoticeContent = data.result.notice_content
        this.myNoticeTitle = data.result.notice_title
        this.isNotice = true
      } else {
        this.onAfterNoticed()
      }
    },
    // async getVerifyCodeUrl() {
    //   try {
    //     this.verifyCodeUrl = await getCaptchaUrl() // 获取图片img base64地址
    //   } catch (error) {
    //     //window.alert(`错误信息：${error.message}, 错误代码：${error.code}`)
    //   }
    // },
    async checkBlock() {
      let blockedVisit = await verifyIpAddress()
     
      this.blockedVisit = blockedVisit === 'blocked'
      if (this.blockedVisit) {
        this.block_visit = true
        if (this.isMobile) {
          this.showPop = true
          this.popContent = BlockedVisitMSG
        } else {
          this.verity.curTips = BlockedVisitMSG
          this.verity.userPassword = true
        }
        return false
      }
      this.block_visit = false
      return true
    },
    async toFindPassWordPage() {
      let blockedFlag = await this.checkBlock()
      if (!blockedFlag) {
        return
      }
      this.$router.push('/findPasswordOne')
    },
    reset() {
      let that = this
      this.$nextTick(function () {
        let body = document.body
        clearTimeout(body.timer)
        body.timer = setTimeout(function () {
          window.innerHeight = that.screenHeight
          window.outerHeight = that.screenHeight
          window.scroll(0, 0)
        }, 150)
      })
    },
    async getAgreements(agree) {
      let data
      if (agree) {
        data = await agreementInfo() || {}
        if (data.result && data.result.notice_content && data.result.notice_title) {
          this.$router.push({path: '/agreementDialogPage', query: {userName: this.userName}})
          return
        } else {
          this.nextStep()
        }
      } else {
        data = await agreement() || {}
        if (data.result) {
          this.$router.push({path: '/agreementDialogPage', query: {userName: this.userName}})
          return
        }
      }
    },
    handlerCloseMessagePop() {
      this.messageBoxShow = false
      // this.getVerifyCodeUrl()
    },
    async sendLoginVoiceMsg(mobile) {
      await sendLoginVoiceMessage(mobile, this.userName, this.userPassword)
    },
    async sendLoginMsg(mobile) {
      await sendLoginMessage(mobile, this.userName, this.userPassword)
    },
    async verifyLoginMsgCode(params) {
      return await verifyLoginMsgCode(params.mobile, params.code)
    },
    async loginVerifyMsgSuccess() {
      this.handlerLogin()
    },
    userLogin: async function () {
      let flag = await this.checkBlock()
     
      if (!flag) {
        return
      }
    // web
      if (!this.isMobile) {
        if (this.userName === '') {
          this.verity.curTips = this.verity.tips[0]
          this.verity.userName = true
          this.verity.userPassword = false
          return
        }
        if (this.userPassword === '') {
          this.verity.curTips = this.verity.tips[1]
          this.verity.userPassword = true
          return
        }
      }
      
      
      const count = await getFailCount(this.userName)

      // 登录三次错误之前先校验账号密码是否正确
      if (count < 3) {
         let result = await queryUserMobile(this.userName, this.userPassword)
        if (result.code === 200) {
          if (result.data) {
            this.messageBoxShow = true
            this.userMobile = String(result.data)
          } else {
            this.handlerLogin()
          }
        } else {
          // count = await getFailCount(this.userName)
          let message = result.message === multiUserValue ? MultiUser : this.verity.tips[2]
          this.popShowErrorMsg(message)
        }
      } else {
       tencentVerification( async(ticket, randStr) => {
          this.ticket = ticket
          this.randStr = randStr
            // 校验账号密码是否 正确
          const result = await queryUserMobile(this.userName, this.userPassword)
            if (result.code === 200) {
              if (result.data) {
                    // 先校验短信验证接口
                try {
                  await sendLoginMessage(String(result.data), this.userName, this.userPassword, this.ticket, this.randStr)
                 
                  this.messageBoxShow = true // 打开短信验证框
                  this.userMobile = String(result.data)
                } catch (e) {
                  if (this.isMobile) {
                    // 手机端，失败
                    this.showPop = true
                    this.popContent = this.verity.tips[5]
                  } else {
                    // web端，失败
                    this.verity.code = true
                    this.verity.verifyCodeTips = this.verity.tips[5]
                  }
                }
              } else {
                this.handlerLogin()
              }
            } else {
              this.tryCount = await getFailCount(this.userName)
              let message = result.message === multiUserValue ? MultiUser : this.verity.tips[2]
              this.popShowErrorMsg(message)
            }
        }, () => {
          this.$message({
          showClose: true,
          message: '网络异常，请稍后重试，或联系工作人员',
          type: 'error',
          center: true,
          customClass: 'custom-message-class' // 自定义类名
        });
        })

      }
 
    },
    handlerLogin() {
      this.catchError(async () => {
        try {
          if (!this.wechatBind) {
            await this.$store.dispatch('login', {
              username: this.userName,
              password: this.userPassword
            })
          } else {
            await this.wechatLogin()
          }
          await checkInitialPasswordLogin();
        } catch (err) {
          let message = err.message === 'blocked' ? BlockedVisitMSG :
              err.message === 'multi-user' ? MultiUser : this.verity.tips[2]

          this.tryCount = await getFailCount(this.userName)
          this.popShowErrorMsg(message)
          if (err.message === 'blocked') {
            this.block_visit = true
            // this.codeStatus = false
          } else {
            this.block_visit = false
          }
          return
        }
        let userInfos = await userInfo()
        // await checkIdCardExpired();
        localStorage.setItem('customerType', userInfos.customer_type)
        this.onAfterNoticed = function () {
          this.getAgreementOnLogin(userInfos)
        }
        this.getNoticeOnLogin()
      })
    },
    popShowErrorMsg(message) {
      if (this.isMobile) {
        this.showPop = true
        this.popContent = message
      } else {
        this.verity.curTips = message
        this.verity.userPassword = true
      }
    },
    successRedirect() {
      const url = localStorage.getItem("wechatUrl1")
      if (this.isMobile) {
        // TODO 根据status的值确定重定向结果
        if (url === '/reportsNoBack') {
          this.$router.replace('/reportsNoBack')
        } else if (url === '/historyTabNoBack?i=1') {
          this.$router.replace('/historyTabNoBack?i=1')
        } else if (url && url.includes('/directFundAndReportMsgPdfWeb')) {
          localStorage.removeItem("wechatUrl1")
          this.$router.replace(`${url}`)
        } else if (url && url.includes('/directImageVideoMp3View')) {
          localStorage.removeItem("wechatUrl1")
          this.$router.replace(`${url}`)
        } else if(url && url.includes('/application-detail')){
          localStorage.removeItem("wechatUrl1")
          this.$router.replace(`${url}`)
        } else {
          this.$router.replace('/myPropertiesTab')
        }
        if (this.isLocalStorageSupported()) {
          localStorage.setItem('userName', this.userName)
        }
      } else {
        if (this.isLocalStorageSupported()) {
          if (this.rememberUsername) {
            localStorage.setItem('userName', this.userName)
          } else {
            localStorage.removeItem('userName')
          }
        }
      }
    },
    async nextStep() {
      this.catchError(async () => {
        if (!this.isMobile) {
          this.$router.push('/myPropertiesTab')
        }
        if (this.$store.state.base.userId) {
          var status = await userStatus()
          if (status) {
            this.$store.commit('setLoginStatus', status)
            if (this.isLocalStorageSupported() && !localStorage.getItem('loginStatus')) {
              localStorage.setItem('loginStatus', status)
            }
            await this.$store.dispatch('loadUser')
            this.status = status
            this.successRedirect()
          }
        }
      })
    },
    async wechatLogin() {
      try {
        await this.$store.dispatch('bindLogin', {
          username: this.userName,
          password: this.userPassword
        })
      } catch (err) {
        let message = err.message === 'blocked' ? BlockedVisitMSG :
            err.message === 'multi-user' ? MultiUser : this.verity.tips[2]
        if (this.isMobile) {
          this.showPop = true
          this.popContent = message
        } else {
          this.verity.curTips = message
          this.verity.userPassword = true
        }
        this.tryCount = await getFailCount(this.userName)

        if (err.message === 'blocked') {
          this.block_visit = true
          // this.codeStatus = false
        } else {
          this.block_visit = false
        }
        return
      }
      if (this.$store.state.base.userId) {
        const status = await userStatus()
        if (status) {
          this.$store.commit('setLoginStatus', status)
          if (this.isLocalStorageSupported() && !localStorage.getItem('loginStatus')) {
            localStorage.setItem('loginStatus', status)
          }
          if (this.isLocalStorageSupported()) {
            localStorage.setItem('userName', this.userName)
          }
        }
      }
    },
    changeUserName(curVal) {
      if (this.isMobile) {
        if (curVal && this.userPassword) {
          this.loginBtnDisabled = false
          this.userPassword = ''
        } else {
          this.loginBtnDisabled = true
        }
      } else {
        if (curVal) {
          this.verity.userName = false
          this.verity.userPassword = false
          this.userPassword = ''
        }
      }
    },
    changeUserPassword(curVal) {
      if (this.isMobile) {
        if (curVal && this.userName) {
          this.loginBtnDisabled = false
        } else {
          this.loginBtnDisabled = true
        }
      } else {
        if (curVal) {
          if (this.userName === '') {
            this.verity.curTips = this.verity.tips[0]
            this.verity.userName = true
          }
          this.verity.userPassword = false
        }
      }

    },
    // async curImgVerify(val) {
    //   // 图片验证
    //   val = val.toLowerCase()
    //   if (!val) {
    //     this.verity.code = true
    //     this.verity.verifyCodeTips = '图形校验码不能为空'
    //     return
    //   }
    //   var result
    //   try {
    //     result = await checkCaptcha(val) // 返回布尔值
    //     if (!result) {
    //       this.verity.code = true
    //       this.verity.verifyCodeTips = '图形校验码错误'
    //     } else {
    //       this.verity.code = false
    //     }
    //   } catch (err) {
    //     console.log('图片验证错误 ,  代码为 : ', err.code, err)
    //   }
    // },
    async geTryCount() {
      this.resetWindow()
      this.tryCount = await getFailCount(this.userName)
    }
  },
  watch: {
    userName: 'changeUserName',
    userPassword: 'changeUserPassword',
    // tryCount: {
    //   handler(newVal) {
    //     if (newVal > 3 && !this.block_visit) {
    //       this.codeStatus = true
    //       // this.getVerifyCodeUrl()
    //     } else {
    //       this.codeStatus = false
    //     }
    //   },
    //   deep: true
    // },
    // rImgVal(cur) {
    //   if (cur !== '') {
    //     this.verity.code = false
    //     if (cur.length >= 15) {
    //       this.verifyCode = cur.substring(0, 15)
    //     } else if (cur.length >= 5) {
    //       this.curImgVerify(cur)
    //     }
    //   }
    // },
    showPassWord(val) {
      this.contentType = val ? 'password' : 'text'
    }
  },
  async mounted() {
    this.clearUser()
    let userName = ''
    if (this.isLocalStorageSupported()) {
      userName = localStorage.getItem('userName')
    }
    this.userName = userName
    if (this.userName === null || this.userName === 'null' || this.userName === undefined || this.userName === 'undefined') {
      this.userName = ''
    }
    this.tryCount = await getFailCount(this.userName)
    // if (this.tryCount > 3) {
    //   if (!this.block_visit) {
    //     this.codeStatus = true
    //     // this.getVerifyCodeUrl()
    //   }
    // }
    webTracingClearUserUuid()
  }

}
</script>

<style lang="less">
.custom-message-class {
  min-width: 330px;
}
</style>

<style scoped lang="less">

	.login-mobile-container {
		height: 100%;
		background: #FFFFFF;
		overflow: auto;
		.login-mobile-content{
			overflow: hidden;
			overflow-y: scroll;
			min-height: calc(100% - 70px);
			.item-img {
				margin-top: 57px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.item-info {
				position: relative;
				margin: 28px 20px 0 20px;
				font-size: 18px;
				font-weight: 600;
				line-height: 25px;
			}
			.item-info img{
				position: absolute;
				bottom: 40px;
				right: 0;
			}
			.item-choose {
				margin-left: 20px;
				margin-right: 20px;
				display: flex;
				justify-content: space-between;
				color: #4C7EC5;
				font-size: 12px;
				font-weight: 400;
				line-height: 17px;
				margin-top: 10px;
				span{
					font-size: 16px;
				}
			}
			.item-btn {
				margin-top: 25px;
			}
			.item-regist {
				margin-top: 25px;
				margin-bottom: 25px;
				text-align: center;
				color: #BBBBBB;
				line-height: 18px;
				font-size: 16px;
				font-weight: 400;
				span {
					color: #4C7EC5;
				}
			}
		}
		.item-contect {
			font-size: 12px;
			font-weight: 400;
			color: #BBBBBB;
			line-height: 18px;
			text-align: center;
			margin-bottom: 16px;
		}
	}
	.item-dialog{
		margin-top: 27px;
		margin-bottom: 33px;
		text-align: center;
		min-height:24px;
		font-size:15px;
		line-height:21px;
	}
	.login-container {
		.web-txt-png{
			position: relative;
			bottom: 200px;
			right: 660px;
		}
		.register-agree {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
		.social-account-title {
			font-size: 0;
			white-space: nowrap;
			text-align: center;
			color: #8E9396;
			margin: 19px 0 13px;
			span {
				font-size: 16px;
				vertical-align: middle;
				display: inline-block;
				&.line {
					min-height: 2px;
					min-width: 20%;
					background-color: #ccc;
				}
				&.text {
					width: 46%;
					overflow: hidden;
					text-align: center;
					font-size: 13px;
				}
			}
		}
		.social-account-content {
			width: 36px;
			height: 36px;
			border-radius: 36px / 2;
			margin: 0 auto;
			background-image: url("../assets/weixin.png");
			background-size: 100% 100%;
		}
	}

	.login-footer {
		position: absolute;
		bottom: 10px;
		left: 0;
		width: 100%;
	}

	@media screen and (max-height: 500px) {
		.login-footer {
			display: none;
		}
	}

	span.error-tips {
		line-height: 20px;
		margin: 0;
	}

	.find-password {
		margin-top: 12px;
		text-align: right;
		color: #666;
		font-size: 15px;
		cursor: pointer;
	}

	.login-input-code {
		background-color: #eee;
		margin-bottom: 24px !important;
		display: inline-block;
	}

	.extra img {
		margin-top: 3px;
		width: 112px;
		height: 40px;
	}
	.login-btn-web {
		width: 310px;
		height: 42px;
		border-radius: 4px;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
    border: 0;
		box-shadow: none;
		outline: none;
		background: #c99663;
		&:disabled{
			background: #B3B3B3;
		}
	}
	.register-text {
		color: #BBBBBB;
		text-align: center;
		.register-link {
			cursor: pointer;
			color: #c99663;
		}
	}

 
</style>
